import React from 'react'
import { Typography, TextField, IconButton, CircularProgress, Divider } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import SubScopeChip from './SubScopeChip'

const SubScopePanel = ({ subScopes, onToggle, onAddCustom, onRemoveCustom, saving }) => {
  const [customLabel, setCustomLabel] = React.useState('')

  const predefined = (subScopes || []).filter(s => !s.isCustom)
  const custom = (subScopes || []).filter(s => s.isCustom)

  const handleAdd = () => {
    if (customLabel.trim()) {
      onAddCustom(customLabel.trim())
      setCustomLabel('')
    }
  }

  return (
    <div style={{
      backgroundColor: '#fff', borderRadius: 8,
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: 12, marginBottom: 12
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: 13 }}>Work Types</Typography>
        {saving && <CircularProgress size={14} />}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {predefined.map(s => (
          <SubScopeChip key={s.key} subScope={s} onToggle={onToggle} onRemove={onRemoveCustom} />
        ))}
      </div>
      {custom.length > 0 && (
        <>
          <Divider style={{ margin: '8px 0' }} />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            {custom.map(s => (
              <SubScopeChip key={s.key} subScope={s} onToggle={onToggle} onRemove={onRemoveCustom} />
            ))}
          </div>
        </>
      )}
      <div style={{ display: 'flex', gap: 4, marginTop: 8 }}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Add custom..."
          value={customLabel}
          onChange={e => setCustomLabel(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleAdd())}
          style={{ flex: 1 }}
          inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
        />
        <IconButton size="small" onClick={handleAdd} disabled={!customLabel.trim()}>
          <AddIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  )
}

export default SubScopePanel
